import React from "react";

import Button from "core/Button";

import { useLoginFlow } from "../Context";

const CodeRequestViewButton = ({ children }) => {
    const { goToCodeRequestView } = useLoginFlow();

    return (
        <Button
            onClick={e => {
                e.preventDefault();
                goToCodeRequestView();
            }}
            data-testid="code-request-view-button"
            width="100%"
        >
            {children}
        </Button>
    );
};

export default CodeRequestViewButton;
